import React from 'react';
import Header from '../components/Header';
import HuntGame from '../components/hunt/HuntGame';
import './HuntPage.css';

const HuntPage: React.FC = () => {
    return (
        <div className="Page HuntPage">
            <Header />
            <h1 className="HuntPage-title">Chasse aux Birds</h1>
            <HuntGame />
        </div>
    );
};

export default HuntPage;
